<ng-container *ngIf="!loading">
  <div class="note" *ngIf="note" [ngStyle]="{ background: noteColor }" [innerHTML]="note"></div>
  <button *ngIf="chatAllowed" [style.margin-top]="'2.4rem'" trackable="Edit delivry/Contact us/Chat with us">
    <a (click)="openChat()">
      <common-chat-icon [color]="brandColor"></common-chat-icon>
      <span class="title">Chat with us</span>
    </a>
  </button>
  <button *ngIf="merchantPhone" [style.margin-top]="'2.4rem'" trackable="Edit delivry/Contact us/Call us">
    <a [href]="'tel:' + merchantPhone">
      <common-phone-icon [color]="brandColor"></common-phone-icon>
      <span class="title">Call us</span>
    </a>
  </button>
  <button
    type="button"
    *ngIf="merchantEmail"
    [style.margin-top]="merchantPhone ? undefined : '2.4rem'"
    trackable="Edit delivry/Contact us/Email us">
    <a [href]="'mailto:' + merchantEmail">
      <common-email-icon [color]="brandColor"></common-email-icon>
      <span class="title">Email us</span>
    </a>
  </button>
</ng-container>

<div class="loader" *ngIf="loading">
  <common-animated-svg [loop]="true" [svgName]="'edit-loader'" [height]="44" [width]="44"></common-animated-svg>
</div>
